import { render, staticRenderFns } from "./SettingTrain.vue?vue&type=template&id=2c17aa38&scoped=true&"
import script from "./SettingTrain.vue?vue&type=script&lang=js&"
export * from "./SettingTrain.vue?vue&type=script&lang=js&"
import style0 from "./SettingTrain.vue?vue&type=style&index=0&id=2c17aa38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17aa38",
  null
  
)

export default component.exports